import * as types from "./types";
import {
  getAppIdAxios,
  postAppIdAxios,
  pagePostsAxios,
  deletePostsAxios,
  getScheduledPostsAxios,
  getMarketingCampaignsAxios,
  getCampaignDraftListAxios,
  getCampaignContentsByCampaignIdAxios,
  getMarketingCampaignByIdAxios,
  postMarketingCampaignAxios,
  putMarketingCampaignAxios,
  deleteMarketingCampaignAxios,
  updateMarketingCampaignStatusAxios,
  getCampaignDraftByIdAxios,
  postCampaignDraftAxios,
  putCampaignDraftAxios,
  deleteCampaignAxios,
  postCampaignDraftPublishAxios,
  getEventTaskListAxios,
  postEventTaskAxios,
  putEventTaskAxios,
  postFacebookPostsAxios,
  postLinkedInPostsAxios,
  getCostListAxios,
  getCostByIDAxios,
  postCostAxios,
  putCostAxios,
  deleteCostAxios,
  getTaskListAxios,
  getTaskByIDAxios,
  getAssigneeListAxios,
  postTaskAxios,
  putTaskAxios,
  deleteTaskAxios,
  postSocialPostsAxios,
  postKPIAxios,
  putKPIAxios,
  getMarketingPlanAxios,
  getContentTemplateAxios,
  putAppIdAxios,
  deleteAppIdAxios,
} from "./services";

export async function getAppIdAction({ commit }) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getAppIdAxios();
    commit(types.GET_MARKETING, data.result);

    return data.result;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postAppIdAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await postAppIdAxios(payload);
    commit(types.POST_MARKETING_ID, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function deleteAppIdAction({ commit }, id) {
  commit(types.LOADING_MARKETING, true);
  try {
    console.log("Calling API to delete ID:", id); // Debugging
    await deleteAppIdAxios(id);
    commit(types.DELETE_MARKETING_ID, id);
    console.log("API delete request successful"); // Debugging
  } catch (e) {
    console.error("Error deleting App ID:", e.response ? e.response.data : e.message);
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}


export async function putAppIdAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await putAppIdAxios(payload);
    commit(types.PUT_MARKETING_ID, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getPostAction({ commit }, token) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await pagePostsAxios(token);
    commit(types.GET_POSTS, data.result.data);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function removePostAction({ commit }, token, id) {
  commit(types.LOADING_MARKETING, true);
  try {
    await deletePostsAxios(token, id); // Pass the id parameter here
    commit(types.REMOVE_POST, id);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getScheduledPostAction({ commit }, token) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getScheduledPostsAxios(token);
    commit(types.GET_DRAFTS, data.result.data);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postFacebookAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    return await postFacebookPostsAxios(payload);
    commit(types.FACEBOOK_POST, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postLinkedInAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    return await postLinkedInPostsAxios(payload);
    commit(types.LINKEDIN_POST, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postSocialAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    return await postSocialPostsAxios(payload);
    commit(types.SOCIAL_POST, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getCampaignsListAction({ commit }) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getMarketingCampaignsAxios();
    commit(types.GET_CAMPAIGNS_LIST, data.result);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postMarketingCampaignAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await postMarketingCampaignAxios(payload);
    commit(types.POST_MARKETING_CAMPAIGN, payload);
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function putMarketingCampaignAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await putMarketingCampaignAxios(payload);
    commit(types.PUT_MARKETING_CAMPAIGN, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getMarketingCampaignByIDAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getMarketingCampaignByIdAxios(payload);
    commit(types.GET_CAMPAIGNS_BYID, data.result);
    return data.result;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function deleteMarketingCampaignAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await deleteMarketingCampaignAxios(payload);
    commit(types.DELETE_CAMPAIGN, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function updateMarketingCampaignStatusAction(
  { commit },
  { id, status }
) {
  commit(types.LOADING_MARKETING, true);
  try {
    const response = await updateMarketingCampaignStatusAxios(id, status);
    commit(types.UPDATE_CAMPAIGN_STATUS, { id, status });
    return response;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

// export async function updateEmailCampaignStatusAction({ commit }, { id, status }) {
//   commit(types.LOADING_EMAILCAMPAIGN, true);
//   try {
//       const response = await updateCampaignStatus(id, status);
//       commit(types.UPDATE_EMAILCAMPAIGN_STATUS, { id, status });
//       return response;
//   } catch (e) {
//       throw e;
//   } finally {
//       commit(types.LOADING_EMAILCAMPAIGN, false);
//   }
// }

export async function getCampaignDraftListAction({ commit }) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getCampaignDraftListAxios();
    commit(types.GET_CAMPAIGN_DRAFT_LIST, data.result);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postCampaignDraftAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const response = await postCampaignDraftAxios(payload);
    commit(types.POST_CAMPAIGN_DRAFT, response.data);
    return response.data;
  } catch (e) {
    console.error("Error in action:", e);
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}
export async function putCampaignDraftAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await putCampaignDraftAxios(payload);
    commit(types.PUT_CAMPAIGN_DRAFT, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getCampaignDraftByIDAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getCampaignDraftByIdAxios(payload);
    commit(types.GET_CAMPAIGN_DRAFT_BYID, data.result);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}   

export async function getCampaignContentsByCampaignIdAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getCampaignContentsByCampaignIdAxios(payload);
    commit(types.GET_CAMPAIGN_CONTENTS_BYID, data.result);
    return data.result;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function deleteCampaignDraftAction({ commit }, campaignContentsId) {
  commit(types.LOADING_MARKETING, true);
  try {
    await deleteCampaignAxios(campaignContentsId);
    commit(types.DELETE_CAMPAIGN_DRAFT, campaignContentsId);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postPublishDraftAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await postCampaignDraftPublishAxios(payload);
    commit(types.PUBLISH_DRAFT, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getEventTaskListAction({ commit }) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getEventTaskListAxios();
    commit(types.GET_EVENT_TASK_LIST, data.result);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postEventTaskAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await postEventTaskAxios(payload);
    commit(types.POST_EVENT_TASK, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function putEventTaskAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await putEventTaskAxios(payload);
    commit(types.PUT_EVENT_TASK_STATUS, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getCostListAction({ commit }, campaignId) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getCostListAxios(campaignId);
    commit(types.GET_COST_LIST, data.result);
    return data.result;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getCostByIdAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getCostByIDAxios(payload);
    commit(types.GET_COST_BYID, data.result);
    return data.result;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postCostAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await postCostAxios(payload);
    commit(types.POST_COST, payload);
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function putCostAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await putCostAxios(payload);
    commit(types.PUT_COST, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function deleteCostAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    await deleteCostAxios(payload);
    commit(types.DELETE_COST, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getTaskListAction({ commit }, campaignId) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getTaskListAxios(campaignId);
    if (data && Array.isArray(data.data)) {
      commit(types.GET_TASK_LIST, data.data);
      return data.data;
    } else {
      console.error("Unexpected API structure:", data);
      return [];
    }
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getTaskByIdAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getTaskByIDAxios(payload);
    commit(types.GET_TASK_BYID, data.result);
    return data.result;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function postTaskAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const response = await postTaskAxios(payload);

    if (response.data && response.data.success) {
      commit(types.POST_TASK, response.data.result); // Commit task to store if needed
      return response.data; // Return the full API response
    } else {
      throw new Error(response.data.message || "Failed to add task.");
    }
  } catch (e) {
    console.error("Error in postTaskAction:", e);
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function putTaskAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
      const response = await putTaskAxios(payload);
      commit(types.PUT_TASK, response.data.result); // Commit the updated task to the store
      return response.data;
  } catch (e) {
      console.error("Error updating task:", e);
      throw e;
  } finally {
      commit(types.LOADING_MARKETING, false);
  }
}

export async function deleteTaskAction({ commit }, taskId) {
  commit(types.LOADING_MARKETING, true);
  try {
    const response = await deleteTaskAxios(taskId);
    if (response.status === 200 && response.data.success) {
      commit(types.DELETE_TASK, taskId);
      return response.data;
    } else {
      throw new Error(response.data.message || "Failed to delete task.");
    }
  } catch (error) {
    console.error("Error deleting task:", error);
    throw error;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getAssigneeListAction({ commit }) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getAssigneeListAxios();

    if (data && data.success && Array.isArray(data.result)) {
      commit(types.GET_ASSIGNEE_LIST, data.result);
      return data.result;
    } else {
      console.error("Unexpected API structure:", data);
      return [];
    }
  } catch (e) {
    console.error("Error fetching assignees:", e);
    return [];
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}


export async function postKPIAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
    const response = await postKPIAxios(payload);

    if (response.data && response.data.success) {
      commit(types.POST_KPI, response.data.result); // Commit task to store if needed
      return response.data; // Return the full API response
    } else {
      throw new Error(response.data.message || "Failed to add kpi.");
    }
  } catch (e) {
    console.error("Error in postTaskAction:", e);
    throw e;
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function putKPIAction({ commit }, payload) {
  commit(types.LOADING_MARKETING, true);
  try {
      const response = await putKPIAxios(payload);
      commit(types.PUT_KPI, response.data.result); // Commit the updated task to the store
      return response.data;
  } catch (e) {
      console.error("Error updating kpi:", e);
      throw e;
  } finally {
      commit(types.LOADING_MARKETING, false);
  }
}

//marketing plan getMarketingPlanAxios
export async function getMarketingPlanAction({ commit }) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getMarketingPlanAxios();

    if (data && data.success && Array.isArray(data.result)) {
      commit(types.GET_MARKETING_PLAN, data.result);
      return data.result;
    } else {
      console.error("Unexpected API structure:", data);
      return [];
    }
  } catch (e) {
    console.error("Error fetching marketingplan:", e);
    return [];
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}

export async function getContentTemplateAction({ commit }, platformName) {
  commit(types.LOADING_MARKETING, true);
  try {
    const { data } = await getContentTemplateAxios(platformName);

      commit(types.GET_MARKETING_TEMPLATE, data);
      return data;

  } catch (e) {
    console.error("Error fetching marketingTemplate:", e);
    return [];
  } finally {
    commit(types.LOADING_MARKETING, false);
  }
}